<template>
<!-- 组织机构图组件 -->
  <div class="kw_seeks_relation" v-loading="loading" style="width:100%;height:calc(100vh - 190px);" @click="isShowNodeMenuPanel = false">
    <SeeksRelationGraph ref="seeksRelationGraph" :options="graphOptions" :on-node-expand="onNodeExpand" :on-node-click="onNodeClick"></SeeksRelationGraph>
    <div v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide)" v-show="isShowNodeMenuPanel" :style="{left: nodeMenuPanelPosition.x + 'px', top: nodeMenuPanelPosition.y + 'px' }" style="z-index: 999;padding:10px;background-color: #ffffff;border:#eeeeee solid 1px;box-shadow: 0px 0px 8px #cccccc;position: fixed;">
      <kw_btn_array :pageSetInfo="(pageSetInfo)" :dataInfo="(currentNode)" :dataIndex="(currentNode.list_index)" @dataButtonClick="dataButtonClick" :isLimitButton="isLimitButton"></kw_btn_array>
    </div>
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="90%" top="1vh" center append-to-body :close-on-click-modal="false" v-dialogDrag>
        <template slot="title"> 
            <div>
                {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
            </div>    
        </template>
        <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
        <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
        <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (tableMaxHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
        <span slot="footer" v-if="dialogInfo.type==999">
            <el-button @click="dialogIframeZdyCancel">取 消</el-button>
            <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';
import SeeksRelationGraph from 'relation-graph'

export default {
  name: 'kw_seeks_relation',
  props: {
    pageSetInfo: {
      type: Object,
      value: {}
    },
    //树的数据内容
    treeData: {
      type: Array,
      value: []
    },
    treeIndex: {
      type: Number,
      value: 1
    },
    //如果是 提供了页面等信息则 在树组件中去获取数据
    initParam: {
      type: Object,
      value: null
    },
    //传入的数据为列表数据 需要进行数据处理
    dataList: {
      type: Array,
      value: null
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading:true,
      graphOptions: {
        debug: true,
        // 'backgrounImage': 'http://ai-mark.cn/images/ai-mark-desc.png',
        // 'backgrounImageNoRepeat': true,
        'moveToCenterWhenResize':false,
        'layouts': [
          {
            'label': '树',
            'layoutName': 'tree',
            'layoutClassName': 'seeks-layout-center',
            'defaultNodeShape': 0,
            'defaultLineShape': 1,
            'from': 'left',
            // 通过这4个属性来调整 tree-层级距离&节点距离
            'min_per_width': undefined,
            'max_per_width': '300',
            'min_per_height': '40',
            'max_per_height': undefined,
            'levelDistance': '' // 如果此选项有值，则优先级高于上面那4个选项
          }
        ],
        'defaultLineMarker': {
          'markerWidth': 12,
          'markerHeight': 12,
          'refX': 6,
          'refY': 6,
          'data': 'M2,2 L10,6 L2,10 L6,6 L2,2'
        },
        "defaultExpandHolderPosition": "right",
        'defaultNodeShape': 1,
        'defaultNodeWidth': '100',
        'defaultLineShape': 4,
        'defaultJunctionPoint': 'lr',
        'defaultNodeBorderWidth': 0,
        'defaultLineColor': 'rgba(0, 186, 189, 1)',
        'defaultNodeColor': 'rgba(0, 206, 209, 1)'
      },
      isShowNodeMenuPanel:false,
      nodeMenuPanelPosition: { x: 0, y: 0 },
      currentNode:{},
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
          ifLoad:false
      },
    };
  },
  created() {
    
  },
  mounted() {
    this.initAttached();
  },
  watch:{
    dataList(){
      this.initAttached();
    }
  },
  computed:{
  },
  components: {
    kw_btn_array,
    SeeksRelationGraph,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    initAttached:function(){
      var that = this;
      that.loading = true;
      if (this.dataList && this.dataList.length > 0) {
        var __graph_json_data = {
          'rootId': '',
          'nodes': [],
          'links': []
        }
        var tableId = that.pageSetInfo.tableId;
        this.dataList.forEach(function (dataOne,dataIndex) {
          if(dataIndex == 0) {
            __graph_json_data.rootId = dataOne['T_' + tableId + '_0']+'';
          }
          dataOne.list_index = dataIndex;
          __graph_json_data.nodes.push({
            'id':dataOne['T_' + tableId + '_0']+'',
            'text':dataOne.NAME,
            'data':dataOne,
          })
          if(dataOne['PID'] > 0) {
            __graph_json_data.links.push({
              'from':dataOne['PID']+'',
              'to':dataOne['T_' + tableId + '_0']+''
            })
          }
        })
        that.loading = false;
        console.log("__graph_json_data====================",__graph_json_data)
        that.$refs.seeksRelationGraph.setJsonData(__graph_json_data, (seeksRGGraph) => {
          // 这些写上当图谱初始化完成后需要执行的代码
        })
      } 
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      this.isShowNodeMenuPanel = false;
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    onNodeExpand(node, e) {
      // 当有一些节点被显示或隐藏起来时，会让图谱看着很难看，需要布局器重新为节点分配位置，所以这里需要调用refresh方法来重新布局
      console.log('onNodeExpand:', node)
      this.$refs.seeksRelationGraph.refresh()
    },
    onNodeClick(nodeObject, $event) {
      this.currentNode = nodeObject.data;
      console.log('showNodeMenus:', $event,nodeObject)
      this.isShowNodeMenuPanel = true
      this.nodeMenuPanelPosition.x = $event.clientX
      this.nodeMenuPanelPosition.y = $event.clientY
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
          this.refreshevent();
      }
    },
    refreshevent() {
        this.$emit("refreshevent");
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
